export interface CommonTableActionPermission {
  showfilter: boolean;
  view: boolean;
  edit: boolean;
  delete: boolean;
  download: boolean;
  stats: boolean;
  showPaginator: boolean;
  restore: boolean;
  viewMore: boolean;
  attach: boolean;
  detach: boolean;
  viewPayload: boolean;
  clone: boolean;
  batchActivity: boolean;
  enableBatch: boolean;
  viewTemplateId: boolean;
  toggle :boolean;
  simulationSettings: boolean;
}